// assets

import BarChartIcon from '@mui/icons-material/BarChart';

// Menus
import { humanitarianOrgMenuItems } from 'pages/humanitarian-organizations/config';
import { corporateMenuItems } from 'pages/corporate/config';
import { merchantMenuItems } from 'pages/merchant/config';
import { decodeToken } from 'utils/functions/jwt-token';

// icons
const icons = {
  BarChartIcon

  // Add more icons as needed
};

const svgIcons = {
  DashboardIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  ProductsIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  SpecificationsIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  StoresIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  CampaignsIcons: '/assets/images/icons/menu-icons/item-icon.svg',
  JobsIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  MarketplaceIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  CataloguesIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  ItemsIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  RecipesIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  TagsIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  CategoriesIcon: '/assets/images/icons/menu-icons/item-icon.svg',
  MenusIcon: '/assets/images/icons/menu-icons/item-icon.svg'
};

const userData = decodeToken();

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const allMenuItems = {
  id: 'allMenuItems',
  // title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'menu.dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.BarChartIcon,
      breadcrumbs: false,
      feature_code: 'personalization'
    }
    // ...(userData.license === 'commercial' ? corporateMenuItems : []),
    // // ...humanitarianOrgMenuItems
    // // ...vaseelahAdminMenuItems
    // ...(userData.license === 'merchant' ? merchantMenuItems : [])
  ]
};

export default allMenuItems;
